export default "__VITE_ASSET__CMk5smvP__"